<template>
  <div v-if="component">
    <div class="controls" v-if="currentPreset">
      <!-- Single button triggers two b-collapse components -->
      <b-row>
        <b-col cols="1" v-if="!$screen.sm" align-self="center">
          <b-icon icon="list" style="font-size:20px" @click="forceShowHeader = !forceShowHeader" />
        </b-col>

        <b-col cols="2" sm="1">
          <b-btn variant="success" to="create" :append="true" v-if="$can('create ' + this.component.general.name)">
            <span v-if="$screen.md && $screen.lg">{{ $t('create') }}</span>
            <span v-else>+</span>
          </b-btn>
        </b-col>
        <b-col cols="1">
          <b-dropdown size="sm" id="ddown_link" text="Actions" variant="link">
            <b-dropdown-item @click="importData.modal = true">{{ $t('import') }}</b-dropdown-item>
            <b-dropdown-item @click="runExport">{{ $t('export') }}</b-dropdown-item>
          </b-dropdown>
          <b-modal v-model="importData.modal" :title="`${$t('import')}`" @ok="runImport()"
            :ok-title="`${$t('import')}`">
            <b-form-group label="File">
              <b-form-file v-model="importData.file" />
            </b-form-group>
            <b-form-group label="Field map" description="Map fields from imported file to component fields">
              <b-row v-for="(i, f) in Object.keys(importData.fieldMap)" :key="f" class="mb-2">
                <b-col cols="4"><b-input v-model="importData.fieldMap[i].from" /></b-col>
                <b-col cols="4"><b-form-select v-model="importData.fieldMap[i].to"
                    :options="availableFields.map(f => { return { text: f.key, value: f.key } })" /></b-col>
                <b-col cols="4" @click="removeFieldMap(i)"><i class="fa fa-trash"></i></b-col>
              </b-row>
              <b-button @click="addFieldMap">{{ $t('add') }}</b-button>
            </b-form-group>
            <b-form-group label="Primary ID"
              description="Fields that match with this primary id field will be instead updated and not created as new. If left blank all models will be created as new.">
              <b-form-select v-model="importData.primaryKey"
                :options="availableFields.map(f => { return { text: f.key, value: f.key } })" />
            </b-form-group>
            <HowItWorksPopup>
              {{ $t('fieldsCsv') }}
            </HowItWorksPopup>
          </b-modal>
        </b-col>
      </b-row>
    </div>

    <b-card show-footer v-if="this.currentPreset">
      <div slot="header" v-if="showHeader">
        <b-row>
          <b-col cols="12">
            <b-form-group :label="`${$t('preset')}`" label-cols-md="1" class="mb-0">
              <b-row>
                <b-col cols="8" md="3">
                  <b-select v-model="filterPreset" :options="availablePresets"></b-select>
                </b-col>

                <b-col cols="3" align-self="center">
                  <b-row>
                    <b-col cols="12">
                      <b-dropdown size="sm" id="ddown_link" :text="$t('options')" variant="link" class="m-0">
                        <b-dropdown-item v-if="this.filterPreset != 'Default'" @click="updatePreset()">{{ $t('update')
                          }}</b-dropdown-item>
                        <b-dropdown-item v-if="this.filterPreset != 'Default'" @click="deletePreset()">{{ $t('delete')
                          }}</b-dropdown-item>
                        <b-dropdown-item v-if="!this.currentPreset.context.default && this.filterPreset != 'Default'"
                          @click="setAsDefault()">{{ $t('setDefault') }}</b-dropdown-item>
                        <b-dropdown-item @click="fork.modal = true"> {{ $t('fork') }} </b-dropdown-item>
                        <b-dropdown-item to="settings#list" :append="true">{{ $t('settings') }}</b-dropdown-item>
                      </b-dropdown>
                    </b-col>
                    <b-col cols="12">
                      <b-modal hide-header v-model="fork.modal" ok-only :ok-title="`${$t('fork')}`" @ok="forkIt">
                        <b-input v-model="fork.name" :placeholder="`${$t('newFilterName')}`" />
                      </b-modal>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

            </b-form-group>
          </b-col>

          <b-col md="2" v-if="$can('settings ' + this.component.general.name)">

          </b-col>
        </b-row>

        <hr />

        <b-row size="12">
          <b-col lg="3">
            <b-form-group :label="`${$t('field')}:`" label-cols-sm="2" label-cols-md="3" class="mb-0">

              <b-form-select @change="filterOnChange()" :options="dateFieldOptions" id="dateField"
                v-model="currentPreset.context.filters.dateField" class="mb-2"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-form-group :label="`${$t('from')}:`" label-cols-sm="2" label-cols-md="3" class="mb-0">

              <b-form-datepicker :date-format-options="dateFormat" locale="en-US" @context="filterOnChange()"
                :label-no-date-selected="$t('noDateSelected')" id="dateFrom"
                v-model="currentPreset.context.filters.dateFrom" class="mb-2" reset-button></b-form-datepicker>
            </b-form-group>

          </b-col>

          <b-col lg="3">
            <b-form-group :label="`${$t('to')}:`" label-cols-sm="2" label-cols-md="3" class="mb-0">

              <b-form-datepicker :date-format-options="dateFormat" locale="en-US" @context="filterOnChange()"
                :label-no-date-selected="$t('noDateSelected')" id="dateTo"
                v-model="currentPreset.context.filters.dateTo" class="mb-2" reset-button></b-form-datepicker>
            </b-form-group>

          </b-col>


          <b-col lg="3">
            <AdvancedFilters v-model="currentPreset.context.expr" @apply="applyAdvancedFilters" />
          </b-col>

        </b-row>

        <b-row size="12">
          <b-col sm="3">
            <b-input-group>
              <b-form-input v-model="currentPreset.context.filters.filter" type="search" id="filterInput"
                :placeholder="`${$t('search')}`"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!currentPreset.context.filters.filter"
                  @click="currentPreset.context.filters.filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <b-col sm="8" v-if="availableFilterFields > 0">
            <b-form-group :label="`${$t('filterOn')}`" label-cols-sm="3" label-align-sm="right" label-size="sm"
              :description="`${$t('leaveUnchecked')}`" class="mb-0">
              <b-form-checkbox-group v-model="currentPreset.context.filters.filterOn" class="mt-1"
                @change="filterOnChange">
                <b-form-checkbox v-for="field in availableFilterFields" :value="field.key" v-bind:key="field.key"> {{
                  field.label || field.key }} </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>

        <br />

        <b-dropdown size="sm" id="quick_actions" :text="`${$t('choose')}...`" variant="link" class="m-0"
          v-if="itemsSelected.length > 0">
          <b-dropdown-item @click="multiAction('delete')">{{ $t('delete') }}</b-dropdown-item>
          <template v-if="settings.model.disable">
            <b-dropdown-item @click="multiAction('disable')">{{ $t('disable') }}</b-dropdown-item>
            <b-dropdown-item @click="multiAction('enable')">{{ $t('enable') }}</b-dropdown-item>
          </template>
        </b-dropdown>
      </div>

      <b-row v-if="settings.model.disable"><b-col sm="5">
          <b-form-group :label="`${$t('showDisabled')}`" label-for="module" :label-cols="5" label-cols-sm="5"
            :horizontal="false">
            <c-switch class="mx-1" color="success" variant="pill" :label="true" :dataOn="`${$t('yes')}`"
              :dataOff="`${$t('no')}`" v-model="showDisabled" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-table v-if="tableReady" filter-debounce="500" ref="table" :filter="currentPreset.context.filters.filter"
        :filterIncludedFields="currentPreset.context.filters.filterOn" :responsive="true" :items="provider"
        :fields="availableFields" :current-page="page" :per-page="10" @row-clicked="edit" :busy="busy">
        <template v-slot:cell(multiselect)="item">
          <b-form-group :label-for="item.item.uuid" @click="(e) => { e.preventImmidiatePropagation() }">
            <b-form-checkbox :id="item.item.uuid" :name="item.item.uuid" :value="item.item.uuid" v-model="itemsSelected"
              style="position: relative"></b-form-checkbox>
          </b-form-group>
        </template>

        <template v-slot:[fieldCell(field.key)]="item" v-for="field in availableIdentityFields">
          <ListFormatterResolver :field="field" :item="item.item" :key="field.key" />
        </template>

        <template v-slot:cell(actions)="item">
          <b-row>
            <b-col cols="12" align-self="center" style="cursor:pointer"> <b-icon icon="pencil"
                @click="(e) => quickActionEdit(e, item)" /></b-col>
          </b-row>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-skeleton width="100%" height="150px" animation="throb" />
          </div>
        </template>
      </b-table>

      <b-dropdown size="sm" id="quick_actions" :text="`${$t('choose')}...`" variant="link" class="m-0"
        v-if="itemsSelected.length > 0">
        <b-dropdown-item @click="multiAction('delete')"> {{ $t('delete') }}</b-dropdown-item>
        <template v-if="settings.model.disable">
          <b-dropdown-item @click="multiAction('disable')">{{ $t('disable') }}</b-dropdown-item>
          <b-dropdown-item @click="multiAction('enable')">{{ $t('enable') }}</b-dropdown-item>
        </template>
      </b-dropdown>

      <div slot="footer">
        <nav v-if="totalItems">
          <b-pagination :total-rows="totalItems" :per-page="10" v-model="page" />
          <span>{{ $t('total') }} : {{ totalItems }}</span>
        </nav>
      </div>

      <b-sidebar right v-model="editModel.show" no-backdrop width="500px">
        <Edit :id="$route.meta.ref" :modelUuid="editModel.model.uuid" v-if="editModel.model"
          :key="editModel.model.uuid" :settings="{ container: { cols: 12, md: 12 } }" />
      </b-sidebar>
    </b-card>
    <b-card v-else>
      {{ $t('noDefaultPreset') }}
    </b-card>
  </div>
</template>

<style scoped>
.controls {
  position: relative;
  padding-bottom: 20px;
}

.controls .btn {
  margin-right: 10px;
}

.b-table-sticky-column:last-child {
  right: 0;
}
</style>

<script>
import safeEval from "safe-eval"
import { Switch as cSwitch } from '@coreui/vue'
import _ from 'lodash'
import AdvancedFilters from './AdvancedFilters'
import ListFormatterResolver from '../listFormatters/Resolver'
import moment from 'moment'
import Filters from '../libs/filters'
import HowItWorksPopup from '../elements/HowItWorksPopup'
import Edit from "./Edit.vue"

export default {
  components: {
    cSwitch,
    ListFormatterResolver,
    AdvancedFilters,
    HowItWorksPopup,
    Edit
  },
  props: {
    component: {
      type: Object,
      default: () => null
    }
  },
  data: () => {
    return {
      tableReady: false,
      items: [],
      showDisabled: false,
      currentPage: 1,
      totalItems: null,
      busy: false,
      itemsSelected: [],
      dateFormat: { year: 'numeric', month: 'numeric', day: '2-digit' },
      filtersCopy: null,
      presets: [],
      filterPreset: null,
      fork: {
        modal: false,
        name: ''
      },
      defaultPreset: {
        context: {
          filters: {
            dateField: 'created_at',
            dateFrom: null,
            dateTo: null,
            filter: '',
            filterOn: [],
            $adv: {}
          },
          expr: ''
        },
        name: 'Default'
      },
      importData: {
        modal: false,
        file: null,
        primaryKey: null,
        fieldMap: []
      },
      editModel: {
        model: null,
        show: false
      },

      forceShowHeader: false
    }
  },
  watch: {
    showDisabled() {
      this.$refs.table.refresh()
    },
    filterPreset(val) {
      this.$router.push({ query: { ...this.$route.query, preset: val } })
    }
  },
  computed: {
    settings() {
      return this.component.settings;
    },

    totalRows: function () { return this.pages },
    itemsFiltered() {
      return this.items.filter(i => {
        return (i.disabled_at === null) != this.showDisabled
      })
    },

    availableFilterFields() {
      let fields = this.availableFields

      if (fields !== undefined) {
        return fields.filter(f => {
          return f.filterable
        })
      }

      return []
    },

    showHeader() {
      if (this.forceShowHeader) return true;

      return this.$screen.md && this.$screen.lg
    },

    availableIdentityFields() {
      let fields = this.availableFields

      if (fields !== undefined) {
        return fields.filter(f => {
          return f.key != 'multiselect'
        })
      }

      return []
    },

    dateFieldOptions() {
      let def = [
        {
          text: this.$t('createdAt'),
          value: "created_at"
        },
        {
          text: this.$t('updatedat'),
          value: "updated_at"
        }
      ]

      if (this.settings.fields !== null) {
        this.settings.fields.forEach(f => {
          if (f.type == "date" && f.module == "picker") {
            def.push({
              text: this.$translateLabel(f.label),
              value: f.key
            })
          }

          if (f.type == "datetime" && f.module == "picker") {
            def.push({
              text: this.$translateLabel(f.label),
              value: f.key
            })
          }
        })
      }

      return def
    },

    customDateFields() {
      let r = []

      try {
        let fields = _.get(this.settings, 'fields', []) || []

        fields.forEach(f => {
          if ((f.type == "date" && f.module == "picker") || (f.type == "datetime" && f.module == "picker")) {
            r.push(f.key)
          }
        })

        return r
      } catch (err) {
        this.$debugLog(err)
        this.$bvModal.msgBoxOk(this.$t('confNotValid'))
      }
    },

    availablePresets() {
      return this.presets.map(p => {
        return {
          text: p.name,
          value: p.name
        }
      })
    },

    filters: {
      get() {
        let filters = {
          filter: "",
          filterOn: [],
          dateField: 'created_at',
          dateFrom: null,
          dateTo: null,
          expr: '',
          $adv: {}
        }

        let currentPreset = this.currentPreset
        if (currentPreset) {
          filters = currentPreset.context
        }

        if (this.presets) {
          let preset = this.presets.find(p => {
            return this.filterPreset == p.name
          })

          if (preset !== undefined) {
            let advancedFilters = preset.context

            if (filters.expr != "") {
              advancedFilters = safeEval("(function() { try {" + filters.expr + "} catch(error) { } }())", {
                filters: filters
              })

              if (advancedFilters === undefined) {
                return filters
              }

              return advancedFilters
            }

            return filters
          }
        }

        return filters
      },

      set(val) {
        this.currentPreset.context = val
      }
    },

    currentPreset() {
      let preset = this.presets.find(p => {
        return this.filterPreset == p.name
      })

      if (!preset && this.$isAdmin()) {
        return {
          context: {
            filters: {
              dateField: 'created_at',
              dateFrom: null,
              dateTo: null,
              filter: '',
              filterOn: [],
              $adv: {}
            },
            expr: ''
          },
          name: 'Default'
        }
      }

      return preset
    },

    page: {
      get() {
        let currentPage = this.$route.query.page
        if (currentPage) {
          return currentPage
        }

        return 1
      },

      set(val) {
        this.$router.push({ query: { ...this.$route.query, page: val } })
      }
    },

    availableFields() {
      let fields = _.cloneDeep(this.settings.fields) || []

      fields.map(f => {
        f.label = this.$translateLabel(f.label, f.name)

      })

      fields.sort((a, b) => {
        return a.sortOrder - b.sortOrder
      })

      fields.push({
        key: "created_at",
      })

      fields.push({
        key: "updated_at"
      })

      let f = fields.map(f => {
        f.sortable = true
        f.thStyle = { whiteSpace: 'nowrap' }

        return f
      })

      f.unshift({
        key: "multiselect",
        label: ""
      })

      f.unshift({
        key: "actions",
        label: "",
      })

      return f
    },
  },
  methods: {
    getBadge(status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    getRowCount: function () {
      return this.totalItems
    },
    edit(item) {
      this.$router.push({ path: "edit/" + item.uuid, append: true })
    },

    provider(ctx, callback) {
      let expr = this.currentPreset.context.expr
      let filters = this.currentPreset.context.filters

      filters.perPage = ctx.perPage
      filters.currentPage = this.page
      filters.sortDesc = ctx.sortDesc
      filters.sortBy = ctx.sortBy

      let result = safeEval("(function() { try {" + expr + " return filters;} catch(error) { console.log(error) } }())", {
        filters: new Filters(filters),
        _: _,
        moment: moment
      })

      if (result !== undefined) {
        this.currentPreset.context.filters = Object.assign({}, this.currentPreset.context.filters, result)
      }

      var self = this

      this.$store.dispatch('fetchComponentsModels', {
        uuid: this.$route.meta.ref,
        context: this.currentPreset.context.filters,
        buildTTL: 5
      }).then(data => {
        let items = _.get(data, 'items', []).map(i => {
          i.created_at = this.$toUserTimeZone(i.created_at);
          i.updated_at = this.$toUserTimeZone(i.updated_at);
          i.deleted_at = this.$toUserTimeZone(i.deleted_at);
          i.disabled_at = this.$toUserTimeZone(i.disabled_at);

          if (self.customDateFields) {
            self.customDateFields.forEach(k => {
              i[k] = this.$toUserTimeZone(i[k])
            })
          }

          return i;
        })

        this.totalItems = data.total
        this.pages = data.pages

        callback(items)

      }).catch(err => {
        this.$debugLog(err)

        if (err.response !== undefined) {
          if (err.response.status == 500) {
            this.$serverErrorModal(err)
            return
          }

          this.$bvModal.msgBoxOk(err.response.data.message);
        }

        callback([])
        this.totalItems = 0

        this.$bvToast.toast(this.$t("unexpectedError"), {
          title: this.$t("unexpectedErrorHappened"),
          variant: "danger"
        })
      })
    },

    filterOnChange() {
      if (this.$refs.table)
        this.$refs.table.refresh()
    },

    quickActionDelete(e, item) {
      e.stopImmediatePropagation()

      item = item.item
      let componentUuid = this.$route.meta.ref

      this.$bvModal.msgBoxConfirm(this.$t('areYouSure')).then((resp) => {
        if (resp) {
          const popup = this.$loadingPopup()

          this.$http.delete("/v3/system/component/" + componentUuid + "/model/" + item.uuid).then(() => {
            this.$store.commit("REMOVE_COMPONENTS_MODEL", { uuid: componentUuid, model_uuid: item.uuid })
            this.$refs.table.refresh()
          }).catch((error) => {
            if (error.response === undefined) {
              this.$serverErrorModal(error)
              return
            }

            if (error.response.status == 500) {
              this.$serverErrorModal(error)
              return
            }

            this.$bvToast.toast(this.$t('somethingWrong'), {
              variant: 'warning',
              title: "Warning"
            })
          }).finally(() => {
            popup.hide()
          })
        }
      })

    },

    quickActionEdit(e, item) {
      e.stopImmediatePropagation()

      item = item.item

      this.editModel.model = item
      this.editModel.show = true
    },

    multiAction(action) {
      let componentUuid = this.$route.meta.ref

      this.$bvModal.msgBoxConfirm(this.$t('areYouSure')).then((resp) => {
        if (resp) {
          this.$http.post("/v3/system/component/" + componentUuid + "/" + action + "/models", { items: this.itemsSelected }).then(() => {
            this.$refs.table.refresh()
            this.itemsSelected = []
          }).catch((error) => {
            if (error.response === undefined) {
              this.$serverErrorModal(error)
              return
            }

            if (error.response.status == 500) {
              this.$serverErrorModal(error)
              return
            }

            this.$bvToast.toast(this.$t('somethingWrong'), {
              variant: 'warning',
              title: "Warning"
            })
          })
        }
      })
    },

    filterFieldForFormatter(field) {
      let fields = this.settings.fields;

      // find field by key
      let ff = fields.find(f => {
        return f.key == field
      })

      return ff
    },

    fieldCell(field) {
      //console.log(field)
      return `cell(${field})`;
    },

    forkIt() {
      let name = this.fork.name

      let newPreset = _.cloneDeep(this.currentPreset)
      newPreset.name = name

      let currentSettings = this.settings

      if (!currentSettings.presets) {
        currentSettings.presets = []
      }

      currentSettings.presets.push(newPreset);

      currentSettings.presets = currentSettings.presets.filter(p => {
        return p.name != 'Default'
      })

      this.$store.dispatch("updateComponentSettings", { ...this.component, settings: currentSettings }).then(() => {

        this.$bvToast.toast("Preset saved", {
          variant: 'success',
          title: "Success"
        })
      }).catch((err) => {
        this.$debugLog(err)
        this.$bvToast.toast("Failed to save preset", {
          variant: 'warning',
          title: "Warning"
        })

      })
    },

    updatePreset() {
      let presets = this.presets.map(p => {
        if (this.filterPreset == p.name) {
          return this.currentPreset
        }

        return p
      })

      let currentSettings = this.settings
      currentSettings.presets = presets;

      currentSettings.presets = currentSettings.presets.filter(p => {
        return p.name != 'Default'
      })

      this.$store.dispatch("updateComponentSettings", { ...this.component, settings: currentSettings }).then(() => {

        this.$bvToast.toast(this.$t('presetUpdated'), {
          variant: 'success',
          title: "Success"
        })
      }).catch(() => {
        this.$bvToast.toast(this.$t('failedUpdate'), {
          variant: 'warning',
          title: "Warning"
        })

      })

    },

    deletePreset() {
      let presets = this.presets.filter(p => {
        return this.currentPreset.name != p.name
      })

      let currentSettings = this.settings
      currentSettings.presets = presets;

      currentSettings.presets = currentSettings.presets.filter(p => {
        return p.name != 'Default'
      })

      this.$store.dispatch("updateComponentSettings", { ...this.component, settings: currentSettings }).then(() => {
        this.presets = presets;
        this.filterPreset = this.presets[0].name;

        this.$bvToast.toast(this.$t('presetRemoved', { name: this.currentPreset.name }), {
          variant: 'success',
          title: "Success"
        })
      }).catch(() => {

        this.$bvToast.toast(this.$t('failedRemove'), {
          variant: 'warning',
          title: "Warning"
        })
      })
    },

    setAsDefault() {
      let presets = this.presets.map(p => {
        p.context.default = false

        if (this.filterPreset == p.name) {
          p.context.default = true
        }

        return p
      })

      let currentSettings = this.settings
      currentSettings.presets = presets;
      currentSettings.presets = presets;

      currentSettings.presets = currentSettings.presets.filter(p => {
        return p.name != 'Default'
      })

      this.$store.dispatch("updateComponentSettings", { ...this.component, settings: currentSettings }).then(() => {
        this.presets = presets

        this.$bvToast.toast(this.$t('presetIsDefault', { name: this.filterPreset }), {
          variant: 'success',
          title: "success"
        })
      }).catch(() => {

        this.$bvToast.toast(this.$t('failedToSetDefault'), {
          variant: 'warning',
          title: "Warning"
        })
      })

    },

    applyAdvancedFilters(data) {
      this.currentPreset.context.expr = data
      this.$refs.table.refresh()
    },

    runImport() {
      let file = this.importData.file
      let formData = new FormData();

      formData.append('file', file)
      formData.append('primary_key', this.importData.primaryKey || "")
      formData.append('field_map', JSON.stringify(this.importData.fieldMap) || [])

      this.$http.post("/v1/system/component/" + this.$route.meta.ref + "/import", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((resp) => {
        console.log(resp)
      }).catch(error => {
        if (error.response.status == 500) {
          this.$serverErrorModal(error)
          return
        }

        if (error.response.status == 417) {
          this.$bvModal.msgBoxOk(this.$t("fieldsNotValid"))
          return
        }

        this.$bvModal.msgBoxOk(error.response.data.message)
      })
    },

    runExport() {
      this.provider({}, (items) => {
        const blob = new Blob([JSON.stringify(items)], { type: 'text/plain' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = this.$route.meta.ref + ".json"
        link.click()
        URL.revokeObjectURL(link.href)
      })
    },

    addFieldMap() {
      this.importData.fieldMap.push({
        from: '',
        to: ''
      })
    },

    removeFieldMap(i) {
      this.importData.fieldMap.splice(i, 1)
    }
  },
  mounted() {
    if (!this.$can("see " + this.component.general.name)) {
      if (!this.$isAdmin()) {
        this.$router.back()
      }
    }

    this.presets = []

    //this.$store.dispatch("fetchComponentsSettings", this.$route.meta.uuid).then(data => {

    let settings = this.settings
    if (!settings.presets) {
      settings.presets = []
    }

    this.presets = settings.presets
    if (this.presets) {
      let foundDefault = this.presets.find(p => {
        return p.name == 'Default'
      })

      if (!foundDefault && (this.$isAdmin() || this.$store.getters.getCurrentEnv == 'dev')) {
        this.presets.push(this.defaultPreset)
      }

      let def = this.presets.find(p => {
        return p.context.default
      })

      if (def) {
        this.filterPreset = def.name
      } else {
        if (this.presets[0] !== undefined) {
          this.filterPreset = this.presets[0].name
        }
      }
    }

    let queryPreset = this.$route.query.preset
    if (queryPreset) {
      this.filterPreset = queryPreset
    }

    this.tableReady = true

    //})


  }
}
</script>